export const UPDATE_USER = 'UPDATE_USER'
export const UPDATE_USER_FAILED = 'UPDATE_USER_FAILED'
export const UPDATE_USER_SUCCEEDED = 'UPDATE_USER_SUCCEEDED'

export const REGISTER_USER = 'REGISTER_USER'
export const REGISTER_USER_FAILED = 'REGISTER_USER_FAILED'
export const REGISTER_USER_SUCCEEDED = 'REGISTER_USER_SUCCEEDED'

export const GET_LOCAL_USER = 'GET_LOCAL_USER'
export const GET_LOCAL_USER_FAILED = 'GET_LOCAL_USER_FAILED'
export const GET_LOCAL_USER_SUCCEEDED = 'GET_LOCAL_USER_SUCCEEDED'

export const GET_USER_PROFILE = 'GET_USER_PROFILE'
export const GET_USER_PROFILE_FAILED = 'GET_USER_PROFILE_FAILED'
export const GET_USER_PROFILE_SUCCEEDED = 'GET_USER_PROFILE_SUCCEEDED'

export const CREATE_USER_INBOX = 'CREATE_USER_INBOX'
export const CREATE_USER_INBOX_FAILED = 'CREATE_USER_INBOX_FAILED'
export const CREATE_USER_INBOX_SUCCEEDED = 'CREATE_USER_INBOX_SUCCEEDED'

export const VERIFY_ACCOUNT_EMAIL = 'VERIFY_ACCOUNT_EMAIL'
export const VERIFY_ACCOUNT_EMAIL_FAILED = 'VERIFY_ACCOUNT_EMAIL_FAILED'
export const VERIFY_ACCOUNT_EMAIL_SUCCEEDED = 'VERIFY_ACCOUNT_EMAIL_SUCCEEDED'

export const REGISTER_USER_BY_OAUTH2 = 'REGISTER_USER_BY_OAUTH2'
export const REGISTER_USER_BY_OAUTH2_FAILED = 'REGISTER_USER_BY_OAUTH2_FAILED'
export const REGISTER_USER_BY_OAUTH2_SUCCEEDED = 'REGISTER_USER_BY_OAUTH2_SUCCEEDED'

export const RESEND_ACCOUNT_VERIFICATION_EMAIL = 'RESEND_ACCOUNT_VERIFICATION_EMAIL'
export const RESEND_ACCOUNT_VERIFICATION_EMAIL_FAILED = 'RESEND_ACCOUNT_VERIFICATION_EMAIL_FAILED'
export const RESEND_ACCOUNT_VERIFICATION_EMAIL_SUCCEEDED =
  'RESEND_ACCOUNT_VERIFICATION_EMAIL_SUCCEEDED'

export const SHOW_REGISTRATION_ERROR = 'SHOW_REGISTRATION_ERROR'
export const CLEAR_REGISTER_USER_ERROR = 'CLEAR_REGISTER_USER_ERROR'
